// extracted by mini-css-extract-plugin
export default {"BarGraph":"Ratings_BarGraph__xNMvI","maxIndicator":"Ratings_maxIndicator__YAdZR","minIndicator":"Ratings_minIndicator__Rp9nJ"};